import { render, staticRenderFns } from "./DeleteViolationModal.vue?vue&type=template&id=45db3a70&"
import script from "./DeleteViolationModal.vue?vue&type=script&lang=js&"
export * from "./DeleteViolationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports